// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__1ONrn","content":"layout_content__31sLk"};